import React, { useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { uniqBy } from 'lodash';
import { frontloadConnect } from 'react-frontload';

import BreadCrumbSelector from '../BreadCrumb/BreadCrumbSelector';
import StandortLink from '../VHost/StandortLink';
import { standortUrlSelector } from '../../../modules/selectors/url';
import { ordersSelector } from '../../../modules/selectors/account/orders';
import { fetchOrdersIfNeeded } from '../../../modules/actions/account/orders';

const Layout = function ({ Component, hideBackButton, title, hideLocationSelector, ...rest }) {
    const [selectedLocation, setSelectedLocation] = useState();
    const location = useLocation();
    const standortUrl = useSelector(standortUrlSelector);
    const orders = useSelector(ordersSelector);

    const locations = useMemo(() => {
        const uniqOrders = uniqBy(orders, 'markenStandort._id');
        return uniqOrders.map(order => {
            return {
                value: order.markenStandort._id,
                label: `${order.markenStandort.anschrift.firma}, ${order.markenStandort.anschrift.ort}`,
            };
        });
    }, [orders]);

    const additionalCrumbs = useMemo(() => {
        let url = '';
        return location.pathname
            .split('/')
            .filter(crumb => crumb.length && crumb !== standortUrl)
            .map(crumb => {
                switch (crumb) {
                    case 'account':
                        url += '/account';
                        return {
                            label: 'Mein Konto',
                            url,
                        };
                    case 'orders':
                        url += '/orders';
                        return {
                            label: 'Offene Bestellungen',
                            url,
                        };
                    case 'history':
                        url += '/history';
                        return {
                            label: 'Abgeschlossene Bestellungen',
                            url,
                        };
                    case 'settings':
                        url += '/settings';
                        return {
                            label: 'Meine Einstellungen',
                            url,
                        };
                    default:
                        url += '/';
                        return { label: '', url };
                }
            });
    }, [location.pathname, standortUrl]);

    const handleSelectedLocation = e => setSelectedLocation(e.target.value);

    return (
        <>
            <BreadCrumbSelector additionalCrumbs={additionalCrumbs} />
            <section className="uk-section uk-section-default uk-section-small" data-uk-margin="">
                <div className="uk-container">
                    <div className="uk-child-width-expand uk-flex uk-flex-middle uk-flex-between uk-margin-auto-bottom" data-uk-grid="">
                        <div>
                            <h3 className="uk-margin-remove uk-flex uk-flex-middle">
                                {!hideBackButton && (
                                    <StandortLink
                                        to="/account"
                                        className="uk-icon-button uk-link-reset uk-margin-small-right"
                                        data-uk-tooltip="Zurück zum Kundenkonto"
                                    >
                                        <span data-uk-icon="chevron-left" />
                                    </StandortLink>
                                )}
                                <span>{title}</span>
                            </h3>
                        </div>
                        {!hideLocationSelector && (
                            <div>
                                <select className="uk-select" value={selectedLocation} onChange={handleSelectedLocation}>
                                    <option value="">Alle Standorte</option>
                                    {locations.map(location => (
                                        <option key={location.value} value={location.value}>
                                            {location.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}
                    </div>
                </div>
                <Component orders={orders} selectedLocation={selectedLocation} {...rest} />
            </section>
        </>
    );
};

const frontload = async ({ fetchOrdersIfNeeded }) => await fetchOrdersIfNeeded();

const mapDispatchToProps = {
    fetchOrdersIfNeeded,
};

const mapStateToProps = (Component, wrappedComponentProps) => () => {
    return { Component, ...wrappedComponentProps };
};

function withAccountLayout(Component, props) {
    return connect(
        mapStateToProps(Component, props),
        mapDispatchToProps
    )(frontloadConnect(frontload, { onUpdate: true, noServerRender: true })(Layout));
}

export default withAccountLayout;
